import React from "react";
import Store from "../../content/Store";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import Button from "../shared/buttons/Button";
import { Paths } from "../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import styles from "../../assets/css/modules/home/link-a-plan.css";

export const LinkAPlan = ({ show, content, history }) =>
  show ? (
    <div className="container px-0">
      <div className={styles.linkAPlan + " box"}>
        <div>
          <h3>{content.title}</h3>
          <p>{content.description}</p>
        </div>
        <Button
          label={content.buttonLabel}
          buttonType="secondaryBlueButton"
          onClick={() => history.push(Paths.AddAPlan)}
        />
      </div>
    </div>
  ) : null;

LinkAPlan.content = Store.LinkAPlan;

export const mapStateToLinkAPlan = ({ policyReducer }) => {
  const show =
    policyReducer.selectedPolicy.IsLapsed &&
    !policyReducer.selectedPolicy.IsInternational;
  return { show };
};

export default withRouter(connect(mapStateToLinkAPlan)(Contentify(LinkAPlan)));
